import { render } from "./AddComment.vue?vue&type=template&id=473646d2&scoped=true&ts=true"
import script from "./AddComment.vue?vue&type=script&lang=ts"
export * from "./AddComment.vue?vue&type=script&lang=ts"

import "./AddComment.vue?vue&type=style&index=0&id=473646d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473646d2"]])

export default __exports__